module.exports = __webpack_public_path__ + "assets/27f4280d379b9c402063d70877365144.mp3";